import { render, staticRenderFns } from "./GeneralSettingsTab.vue?vue&type=template&id=1bc87f9c"
import script from "./GeneralSettingsTab.vue?vue&type=script&lang=js"
export * from "./GeneralSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports